module.exports = __webpack_public_path__ + "img/gb-sct.d1d305dc.svg";